/*
 * @Author: zhangsheng
 * @Date: 2023-08-21 10:40:12
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-10-07 10:36:41
 * @FilePath: \panda-index-sicermem-frontend\src\common\utils\util.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import i18n from 'i18next';
const isMobile: boolean = !!navigator.userAgent.match(
  /(phone|pad|pod|iPhone|SymbianOS|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
);
const isImage = (src: string): boolean => /\.(jpe?g|png|svg|gif)$/i.test(src);
const isResource = (src: string): boolean => /\.(eot|woff|woff2|ttf|mp4|avi)$/i.test(src);
const isZh = () => (i18n.language == 'zh' ? '' : '-EN');
const isZhRoute = () => (i18n.language == 'zh' ? '' : '/en');
export { isMobile, isZhRoute, isImage, isResource, isZh };
